import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import SunCalc from 'suncalc';

import moment from 'moment';
import queryString from 'query-string';
import condition from 'ol/events/condition';
import proj from 'ol/proj';
import extent from 'ol/extent';

import Modal from '../layout/Modal';
import MainNavigation from '../layout/MainNavigation';
import DateSelect from '../layout/DateSelect';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import Content from '../layout/Content';
import VisualMenu from '../layout/VisualMenu';

import { visualDeviceStyles } from '../../mapStyles';

const DEFAULT_CENTER = [36.45923015624996, 43.413130671534105];
const DEFAULT_ZOOM = 3;

import {
  toggleProfileMode,
  changeDate,
  toggleDateSelector
} from '../../actions/visual';

import { getFeaturesByProfile, toFeature } from '../../reducers/devices';

import {
  Map,
  TileLayer,
  BingSource,
  Select,
  VectorLayer,
  VectorSource,
  ClusterSource,
  OverLay,
} from '../ol';

import MapWithRouter from '../containers/MapWithRouter';

import styles from './profiles.scss';

class Visual extends Component {

  constructor(props) {
    super(props);

    this.state = {
      allFeatures: [],
      featuresByProfile: {},
      shouldZoomToFit: props.location.search ? false : true,
      sliderValue: 720,
      sunrise: moment(new Date(props.selectedDate)).startOf('day').subtract(12, 'hours').toDate(),
      sunset: moment(new Date(props.selectedDate)).endOf('day').add(12, 'hours').toDate(),
    }

    // this.onMoveEnd = this.onMoveEnd.bind(this);
    // this.featureMouseOn = this.featureMouseOn.bind(this);
    // this.featureMouseOff = this.featureMouseOff.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
    this.isProfileLayerVisible = this.isProfileLayerVisible.bind(this);
  }

  componentDidMount() {
    const { devices, profiles, selectedDate } = this.props;

    this.setState({
      featuresByProfile: getFeaturesByProfile(devices),
      allFeatures: devices.map(toFeature)
    })

    const { lat, lon } = queryString.parse(this.props.location.search)
    if( lat && lon) {
      const sDate = new Date(selectedDate);
      const midday = new Date(sDate.getFullYear(), sDate.getMonth(), sDate.getDate(), 12, 0, 0, 0, 0);
      const { sunrise, sunset } = SunCalc.getTimes(midday, lat, lon);
      this.setState({
        sunrise,
        sunset
      })
    }

    if(!lat && !lon) {
      // let's zoom to fit the features
      const newExtent = extent.boundingExtent(
        this.props.devices.map(d => proj.fromLonLat([d.longitude, d.latitude])),
      );
      if (newExtent[0] !== Infinity) { // yes, this happens appearently
        this.refs.map_component.zoomToExtent(newExtent)
      }
    }
  }

  // componentWillMount() {
  //   this.setLocationFromUrl();
  // }

  componentDidUpdate(prevProps) {
    const { selectedDate } = this.props;

    if(prevProps.location.search !== this.props.location.search || selectedDate !== prevProps.selectedDate) {
      const { lat, lon } = queryString.parse(this.props.location.search)
      const sDate = new Date(selectedDate);
      const midday = new Date(sDate.getFullYear(), sDate.getMonth(), sDate.getDate(), 12, 0, 0, 0, 0);
      if(lat && lon) {
        const { sunrise, sunset } = SunCalc.getTimes(midday, lat, lon);
        this.setState({ sunrise, sunset });
      }
    }

    // Appearently this does not work. The reason the intended behaviour works, is because
    // the component get's remounted on organisation change. Which also does the same:
    //
    // if((prevProps.profiles !== this.props.profiles) || prevProps.devices !== this.props.devices) {
    //   const newFeatures = this.props.devices.map(toFeature)
    //   this.setState({
    //     featuresByProfile: getFeaturesByProfile(this.props.devices),
    //     allFeatures: newFeatures,
    //   })
    // }
  }

  onSliderChange(v) {
    this.setState({
      sliderValue: v
    })
  }

  // featureMouseOn(e) {
  //   const { devices, profiles } = this.props;
  //   this.setState({
  //     hoveredDevice: devices.find(d => d.id === e.element.get("id")),
  //     hoveredProfile: profiles.find(p => p.id === e.element.get("profile_id")),
  //     hoverLocation: e.element.getGeometry().getCoordinates()
  //   })
  // }
  //
  // featureMouseOff(e) {
  //   this.setState({
  //     hoveredDevice: null
  //   })
  // }

  isProfileLayerVisible(profile) {
    if(!profile.astro_clock) {
      return true;
    }
    const { selectedDate } = this.props;
    const { sliderValue, sunrise, sunset } = this.state;

    const selectedTime = moment(new Date(selectedDate)).startOf('day').add(12, 'hours').add(sliderValue, 'minutes');
    if(moment(sunset).add(profile.astro_offset_sunset, 'minutes').isBefore(selectedTime) && moment(sunrise).add(1, 'day').add(profile.astro_offset_sunrise, 'minutes').isAfter(selectedTime)) {
      return true;
    }

    return false;
  }

  render() {
    const {
      activeProfileId,
      loadingDevices,
      loadingProfiles,
      profiles,
      organisationId,
      toggleProfileMode,
      profileMode,
      selectedDate,
      todaysEvents,
      events,
      toggleDateSelector,
      history,
      location
    } = this.props;

    const {
      featuresByProfile,
      allFeatures,
      zoom,
      center,
      hoveredDevice,
      sliderValue,
      sunrise,
      sunset,
    } = this.state;

    //this.isProfileLayerVisible(profile)

    return (
      <div>
        <Content>

          {loadingDevices && <Loading>Loading devices</Loading>}
          <MapWithRouter ref="map_component" location={location} history={history}>
            <TileLayer opacity={1}>
              <BingSource
                apiKey="AkPQjO5c6rlGFZF_PBGt77p7flbuLqSfvOcpwdaaMPIoOVZuiPN_PuR3omBFeICO"
                imagerySet="CanvasDark"
                maxZoom={19} />
            </TileLayer>
            {profiles.map(profile =>
              <VectorLayer visible={this.isProfileLayerVisible(profile)} key={profile.id} style={visualDeviceStyles(profile, sliderValue, profileMode, moment(new Date(selectedDate)).format("ddd").toLowerCase(), todaysEvents)}>
                <VectorSource features={featuresByProfile[profile.id]} />
              </VectorLayer>
            )}
          </MapWithRouter>
          <VisualMenu sunrise={sunrise} sunset={sunset} sliderValue={sliderValue} onSliderChange={this.onSliderChange} profileMode={profileMode} onProfileModeChange={toggleProfileMode} />
        </Content>
        <MainNavigation>
          <DateSelect />
        </MainNavigation>
      </div>
    );
  }
}

export default withRouter(connect(
  ({ devices, profiles, events, ui }, { match }) => ({
    profiles: profiles.data,
    devices: devices.data,
    events: events.data,
    loadingDevices: devices.fetching,
    loadingProfiles: profiles.fetching,
    activeProfileId: match.params.profileId,
    organisationId: match.params.organisationId,
    profileMode: ui.visual.profileMode,
    selectedDate: ui.dateSelector.date,
    todaysEvents: events.data.filter(e => moment(e.event_date).isSame(new Date(ui.dateSelector.date), 'day')),
    events: events.data,
  }),
  dispatch => ({
    toggleProfileMode: () => dispatch(toggleProfileMode())
  })
)(Visual));



// WEBPACK FOOTER //
// ./src/components/pages/Visual.js